import React from "react";
import { useState } from "react";
import { Button } from "../../components/Shared/Buttons/Button";
import { ReactComponent as DropDownIcon } from '../../assets/svg/drop_down.svg';
import { CareerPage } from "./CareerPage";
import { BlueLotus } from "./BlueLotus";
import { LoggedRecruiter } from '../../models/LoggedRecruiter';

interface Props {
    styles: any;
    recruiter: LoggedRecruiter;
}

export const Integration: React.FC<Props> = (props) => {
    const styles = props.styles;
    const [selectedTab, setSelectedTab] = useState("career page");

    return(
        <>
            <div style={styles.mainWrapper}>
                <div style={styles.leftWrapper}>
                    <div style={styles.tabContent}>
                        <Button style={{...styles.tabButton, ...(selectedTab === 'career page' && styles.tabButton.active)}} onClick={()=>setSelectedTab('career page')}>{"Career Page"}
                            <DropDownIcon style={{...styles.tabIcon, ...(selectedTab === 'career page' &&  styles.tabIcon.active)}}/>
                        </Button>
                        <Button style={{...styles.tabButton, ...(selectedTab === 'blue lotus' && styles.tabButton.active)}} onClick={()=>setSelectedTab('blue lotus')}>{"Blue Lotus"}
                            <DropDownIcon style={{...styles.tabIcon, ...(selectedTab === 'blue lotus' &&  styles.tabIcon.active)}}/>
                        </Button>
                    </div>
                </div>
                <div style={styles.rightWrapper}>
                    {selectedTab === "career page" && <CareerPage styles={styles.careerPage} recruiter={props.recruiter}/>}
                    {selectedTab === "blue lotus" && <BlueLotus styles={styles.blueLotus} recruiter={props.recruiter}/>}
                </div>
            </div>
        </>
    )
}